<template>
  <server-error v-if="fetchOfferingsError" />
  <payment-form-page
    v-else
    :initial-values="initialValues"
    :title="title"
    :price="price"
    :payment-date="paymentDate"
    :purchase-loading="loading"
    cancelButtonText="חזרה לתזרים"
    purchase-button-text="לתשלום מאובטח"
    @tokenization-success="onPurchase"
    @cancel="onCancel"
  >
    <template v-slot:disclaimers>
      <offering-terms :iteration-count="3"/>
    </template>
  </payment-form-page>
</template>

<script>
import PaymentFormPage
  from '@/pages/responsive-pages/authenticated/navigation-pages/payment/PaymentForm/PaymentFormPage';
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import { PERSONAL_INFO_FIELDS } from '@/store/modules/payment';
import dateUtils from '@/utils/dates';
import OfferingTerms from '@/pages/responsive-pages/authenticated/offerings/OfferingTerms.vue';
import ServerError from '@/pages/general-errors/ServerError.vue';
import router from '@/router';
import BillyApi from '@/api/BillyApi';
import CashflowSubscriptionApi from '@/api/CashflowSubscriptionApi';
import DDLogs from '@/DDLogs';
import BaseUI from '@riseupil/base-ui';

export default {
  name: 'PurchaseOfferingPayment',
  components: {
    PaymentFormPage,
    OfferingTerms,
    ServerError,
  },
  props: {
    done: { type: Function, require: true },
  },
  async created() {
    this.initialValues[PERSONAL_INFO_FIELDS.firstName] = this.activeMemberFirstName;
    this.initialValues[PERSONAL_INFO_FIELDS.lastName] = this.activeMemberLastName;
    this.initialValues[PERSONAL_INFO_FIELDS.phoneNumber] = this.activeMemberPhoneNumber;
    await this.setAppHeaderProps({
      backgroundColorVariant: BaseUI.LayoutConsts.COLOR_VARIANT.BLUE,
      textColor: BaseUI.Colors.riseupWhite,
      logoColor: BaseUI.Colors.riseupWhite,
      sticky: false,
    });
    try {
      await this.fetchSubscription();
      await this.fetchSubscriptionPricing();
      await this.initializePricing();
    } catch (error) {
      DDLogs.error('Failed to fetch pricing in PurchaseOfferingPayment', { error });
    }
    try {
      await this.fetchOfferings();
    } catch (error) {
      DDLogs.error('Failed to fetch offerings in PurchaseOfferingPayment', { error });
    }
  },
  data() {
    return {
      initialValues: {},
      loading: false,
      offerings: {},
      fetchOfferingsError: false,
    };
  },
  computed: {
    ...mapState('session', ['activeMember']),
    ...mapGetters('session', ['householdName', 'activeMemberFirstName', 'activeMemberLastName', 'activeMemberPhoneNumber']),
    ...mapGetters('featureFlags', ['cashflowHomeBilling']),
    title() {
      return `היי ${this.householdName}, איזה כיף שממשיכים לצמוח יחד!`;
    },
    paymentDate() {
      return dateUtils.normalizeDate(new Date());
    },
    price() {
      const noTrialDiscountOffering = this.offerings.bundleOfferings?.find(offering => offering.id === 'no-trial-discount');
      return noTrialDiscountOffering?.price?.amount;
    },
  },
  methods: {
    ...mapMutations('payment', ['setTokenizationError']),
    ...mapActions('appHeader', ['setAppHeaderProps']),
    ...mapActions('subscription', { fetchSubscription: 'fetchSubscription', fetchSubscriptionPricing: 'fetchPricing' }),
    ...mapActions('pricing', { initializePricing: 'initializePricing' }),
    async fetchOfferings() {
      try {
        this.offerings = await BillyApi.getOfferings();
      } catch (error) {
        DDLogs.error('Failed to fetch offerings', { error });
        this.fetchOfferingsError = true;
      }
    },
    async onPurchase(paymeToken) {
      if (!this.loading) {
        this.loading = true;
        try {
          if (this.cashflowHomeBilling) {
            await CashflowSubscriptionApi.purchaseNtd({ token: paymeToken.token });
          } else {
            const response = await BillyApi.purchaseOffering({
              token: paymeToken.token,
              oneOffOfferings: [],
              subscriptionOfferings: [],
              bundleOfferings: [{
                offeringId: 'no-trial-discount',
                numberOfInstallments: 1,
              }],
            });
            if (response.result !== 'success') {
              DDLogs.errorBusinessEvent('Failed purchasing Offering', { error: response.result });
              this.loading = false;
              this.setTokenizationError(response.result);
              return;
            }
          }
        } catch (error) {
          DDLogs.errorBusinessEvent('Failed purchasing Offering', { error });
          this.loading = false;
          this.setTokenizationError(error);
          return;
        }
        await this.done();
        this.loading = false;
      }
    },
    async onCancel() {
      await router.push({ path: 'home' });
    },
  },
};
</script>

<style scoped>

</style>
